<template>
  <div class="m-card-incard">
    <div class="m-card-incard-header">
      <span class="fz15">@{{data.UserName}}</span> <span class="fz11 m-avatar-name--host" v-if="data.UserName === (data.TopicUserName || PrensenterName)">主持人</span>
      <span class="m-card-incard-time fz12">{{data.CreateTime}}</span>
    </div>
    <div class="m-card-incard-body">
      <p v-html="commentContent" class="fz15"></p>
    </div>
  </div>
</template>

<script>
import {parseContent, parseVideo} from '@/utils/filter'
export default {
  methods: {
    parseContent: parseContent
  },

  computed: {
    commentContent () {
      var content = parseContent(this.data.CommentContent).content
      if (content.length === 0) {
        var imgs = this.data.ImagePath.length > 0 ? this.data.ImagePath.split('|') : []
        if (this.data.UserName === (this.data.TopicUserName || this.PrensenterName) && parseVideo(this.data.CommentContent)) {
          content += '[视频]'
        } else {
          imgs.forEach(() => {
            content += '[图片]'
          })
        }
      }
      return content
    },
    PrensenterName () {
      return this.$store.state.header.pageInfo.PrensenterName
    }
  },

  props: {
    data: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// incard.vue?366d71b2